module.exports = __webpack_public_path__ + "img/productIcon4.fd7ee29f.png";